import { render, staticRenderFns } from "./CourseInsideTitle.vue?vue&type=template&id=357e33cc&scoped=true&"
import script from "./CourseInsideTitle.vue?vue&type=script&lang=js&"
export * from "./CourseInsideTitle.vue?vue&type=script&lang=js&"
import style0 from "./CourseInsideTitle.vue?vue&type=style&index=0&id=357e33cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e33cc",
  null
  
)

export default component.exports